<template>
    <div class="container">
        <van-nav-bar title="新增施工设备" left-text="" right-text="保存" left-arrow @click-left="onClickLeft"
            @click-right="onClickRight">
        </van-nav-bar>

        <div class="menu">
            <van-field readonly clickable label="选择主机" :value="name" placeholder="请选择" @click="showPicker" />
        </div>

        <van-popup v-model="showPopup" round position="bottom">
            <van-picker show-toolbar :columns="engineList" value-key="mainNo" @cancel="showPopup = false"
                @confirm="onConfirm" />
        </van-popup>

    </div>
</template>
  
<script>
import axios from '@/axios.js';
import { NavBar, Icon, Image, Toast, Loading, Picker, Field, Popup, List, } from 'vant';
export default {
    data() {
        return {
            name: "",
            engineId: '',

            showPopup: false,
            showPopup2: false,

            engineList: [],
        };
    },
    components: {
        [NavBar.name]: NavBar,
        [Icon.name]: Icon,
        [Image.name]: Image,
        [Toast.name]: Toast,
        [Loading.name]: Loading,
        [Field.name]: Field,
        [Picker.name]: Picker,
        [Popup.name]: Popup,
        [List.name]: List
    },
    methods: {
        getMainEngine() {
            axios.get("/constructiondevice/alldevicelist?communityId=" + this.$route.query.communityId).then((res) => {
                this.engineList = res.data;
            })
        },

        onClickLeft() {
            this.$router.go(-1);
        },
        onClickRight() {
            if (!this.engineId) {
                Toast('请选择主机');
                return;
            } else {
                axios.post("/constructiondevice/create", {
                    deviceId: this.engineId,
                    constructionCommunityId: Number(this.$route.query.projectId),
                    status: 0,
                }).then((res) => {
                    if (res.isSuccess) {
                        Toast('创建成功');
                        this.$router.go(-1);
                        // this.$router.replace({ path: "constructionDeviceList.html", query: { id: this.$route.query.projectId } });
                    }
                });

            }
        },

        //选择城市
        showPicker() {
            this.showPopup = true;
        },
        onConfirm(item) {
            this.name = item.mainNo;
            this.engineId = item.id;
            this.showPopup = false;
        },
    },
    computed: {
    },
    created() {
        this.getMainEngine();
    },
    mounted() { },
    destroyed() { }
}
</script>
<style lang="less" scoped>
body,
html {
    width: 100%;
    height: 100%;
    background: #F0F4F7
}

.container {
    width: 100%;
    height: 100%;
    letter-spacing: 0px;
    background: #F0F4F7;
}

.list-box {
    width: 100%;
    color: #373737;

    .list {
        font-size: 14px;
        width: 100%;
        background: #fff;
        margin: 12px 0;
        padding: 12px;

        .fl_right {
            text-align: right;
            margin-top: 15px;

            img {
                width: 6px;
                margin-left: 8px;
                margin-bottom: 2px;
                vertical-align: middle;
            }
        }
    }

    .mg10 {
        margin-bottom: 10px;
    }

    .bold {
        font-weight: bold;
    }
}

.menu {
    width: 100%;
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fff;

    .menuitem {
        width: 50%;
        display: inline-block;

        .icon {
            width: 10px;
            height: 6px;
            vertical-align: middle;
        }
    }
}
</style>
  